import Swiper, { Pagination, Autoplay } from 'swiper';

Swiper.use([Pagination, Autoplay]);

/**
 *
 * @constructor
 */
export default function CorrectionResultSlider() {
  const selector = '.correction-result-slider .swiper';
  const element = document.querySelector(selector);
  let countSlides = 0;

  if (element) {
    countSlides = element.querySelectorAll('.swiper-slide').length;
  }

  const pagination = {
    el: '.correction-result-slider .swiper-pagination',
    clickable: true,
    renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
    enabled: true,
  };

  const options = {
    direction: 'horizontal',
    slidesPerView: 4,
    preloadImages: false,
    draggable: true,
    rewind: true,
    pagination,
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
      720: {
        slidesPerView: 2,
      },
      120: {
        slidesPerView: 1,
      },
    },
    autoplay: {
      enabled: true,
      delay: 6000,
      disableOnInteraction: false,
    },
  };

  if (element) {
    let swiper = new Swiper(selector, options);
  }
}
